// extracted by mini-css-extract-plugin
module.exports = {"container__section":"page_container__section__SKEST","address":"page_address__Wy8eP","logoWrap":"page_logoWrap___I76C"};